import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import voucherActivate from './voucherActivate';
import questions from './questions';
import sites from './sites';
import sitesAbn from './sitesAbn';
import jobs from './jobs';
import category from './category';
import location from './location';
import user from './user';
import modals from './modals';
import recommendations from './recommendations';
import messages from './messages';
import contacts from './contacts';
import feedback from './feedback';
import vouchers from './vouchers';
import voucherAdd from './voucherAdd';
import shareableVoucher from './shareableVoucher';
import pages from './pages';
import advertise from './advertise';
import formQuestion from './formQuestion';
import bunnings from './bunnings';
import homepage from './homepage';
import feed from './feed';
import storeLocations from './storeLocations';
import articles from './articles';
import topics from './topics';
import latestArticles from './latest-articles';
import featuredArticles from './featured-articles';
import newsletter from './newsletter';
import states from './states';
import { connectRouter } from 'connected-react-router';
import categories from './categories';
import { fetchReducer as fetch } from '../utils/fetch';
import { doe } from './doe';

const createRootReducer = history =>
  combineReducers({
    questions,
    sites,
    jobs,
    category,
    location,
    user,
    modals,
    recommendations,
    messages,
    contacts,
    feedback,
    vouchers,
    shareableVoucher,
    form: formReducer,
    router: connectRouter(history),
    voucherActivate,
    voucherAdd,
    pages,
    advertise,
    formQuestion,
    bunnings,
    storeLocations,
    homepage,
    feed,
    articles,
    topics,
    latestArticles,
    featuredArticles,
    states,
    categories,
    newsletter,
    sitesAbn,
    fetch,
    doe: doe.reducer,
  });

export type State = ReturnType<ReturnType<typeof createRootReducer>>;

export default createRootReducer;
